(ns manatee.edit.app-db
  (:require [clojure.spec.alpha :as s]
            [manatee.admin.task-config.app-db :as task-config-db]
            [manatee.domain.edit :as domain-edit]
            [manatee.domain.task.spec :as task-spec]
            [taoensso.timbre :as log]
            [utility-belt.uuid :refer [str->uuid]]))

(def edits-root [:edits])
(def edits-path-by-item-id (conj edits-root :by-item-id))
(def edits-path-by-ident (conj edits-root :by-ident))
(def selected-tab-path (conj edits-root :selected-tab))
(def table-component-loading [:qa-edits-loading])
(def compare-options-path (conj edits-root :compare-options))
(def table-params-path [:edits-table-params])

(defn edit-path-by-item-id
  [id]
  (conj edits-path-by-item-id id))

(defn edit-path-by-ident
  [{:keys [user-id item-id]}]
  (conj edits-path-by-ident [user-id item-id]))

(defn- edit-source-edits-by-ident-path
  [edit-source]
  (conj edits-path-by-ident edit-source))

(defn get-edits
  [db]
  (get-in db edits-path-by-item-id {}))

(defn get-edits-by-ident
  [db edit-source]
  (get-in db
          (edit-source-edits-by-ident-path edit-source)
          {}))

(defn get-table-component-loading
  [db]
  (get-in db table-component-loading))

(defn set-table-component-loading
  [db loading?]
  (assoc-in db table-component-loading loading?))

(defn task-config-for-edit
  [db edit]
  {:pre [(contains? edit :task-config-id)]
   :post [(some? %)]}
  (task-config-db/get-task-config db (:task-config-id edit)))

(defn set-edit
  ([db item-id edit]
   (-> db
       (assoc-in (edit-path-by-item-id (str->uuid item-id)) edit)
       (set-edit edit)))
  ([db edit]
   (if (:loading? edit)
     (assoc-in db (edit-path-by-ident edit) edit)
     (let [task-config (task-config-for-edit db edit)
           coerced-edit (domain-edit/coerce edit task-config)
           spec (task-spec/task-config->edit-spec task-config coerced-edit)]
       (if (s/valid? spec coerced-edit)
         (assoc-in db (edit-path-by-ident edit) coerced-edit)
         (do
           (log/errorf "Error setting edit: invalid %s" (s/explain-str spec edit))
           db))))))

(defn unset-edits
  [db]
  (dissoc db :edits))

(defn set-edits-by-item-id
  [db edits]
  (assoc-in db edits-path-by-item-id edits))

(defn set-edits-by-ident
  [db edit-source edits]
  (let [edits (into {}
                    (map (juxt (juxt :user-id :item-id) identity))
                    edits)]
    (assoc-in db
              (edit-source-edits-by-ident-path edit-source) edits)))

(defn table-params
  [db]
  (get-in db table-params-path))

(defn set-table-params
  [db params]
  (assoc-in db table-params-path params))

(defn selected-tab
  [db]
  (get-in db selected-tab-path))

(defn set-selected-tab
  [db tab]
  (assoc-in db selected-tab-path tab))

(defn compare-options
  [db]
  (get-in db compare-options-path))

(defn set-compare-options
  [db tab]
  (assoc-in db compare-options-path tab))
